export default __webpack_public_path__ + "static/media/smartscreen.inline.024234b9.svg";